import { ICreateUserReplyTemplateRequest } from '../repositories/chats/entities/reply_templates/CreateUserReplyTemplateRequest';
import { ICreateUserReplyTemplatesListResponse } from '../repositories/chats/entities/reply_templates/CreateUserReplyTemplatesListResponse';
import { IDeleteUserReplyTemplateRequest } from '../repositories/chats/entities/reply_templates/DeleteUserReplyTemplateRequest';
import { IRecoverUserReplyTemplateRequest } from '../repositories/chats/entities/reply_templates/RecoverUserReplyTemplateRequest';
import { IReplyTemplate } from '../repositories/chats/entities/reply_templates/ReplyTemplate';
import { IUpdateUserReplyTemplateRequest } from '../repositories/chats/entities/reply_templates/UpdateUserReplyTemplateRequest';
import { IUpdateUserReplyTemplateResponse } from '../repositories/chats/entities/reply_templates/UpdateUserReplyTemplateResponse';
import { IUserReplyTemplatesListResponse } from '../repositories/chats/entities/reply_templates/UserReplyTemplatesListResponse';

import type { ERequestApiStatus } from './appState';

export enum EReplyTemplateModalStep {
  List = 'list',
  Create = 'create',
  Edit = 'edit',
  Error = 'error',
}

export type TReplyTemplatesState = {
  data: {
    status: ERequestApiStatus;
    limit: number;
    replyTemplates: IReplyTemplate[];
    errorMessage: string | undefined;
  };
  editableReplyTemplateId: number | null;
  isNewEnabled: boolean;
  isEnabled: boolean;
  isInputButtonVisible: boolean;
  isOnboardingEnabled: boolean;
  isModalOpen: boolean;
  modalStep: EReplyTemplateModalStep | null;
  initialText: string | null;
};

export type {
  IUserReplyTemplatesListResponse,
  ICreateUserReplyTemplatesListResponse,
  IUpdateUserReplyTemplateResponse,
  ICreateUserReplyTemplateRequest,
  IUpdateUserReplyTemplateRequest,
  IRecoverUserReplyTemplateRequest,
  IDeleteUserReplyTemplateRequest,
  IReplyTemplate,
};
